import store from '@/store';
import Base from '@/modules/lawn/components/ModuleBase';
import ProjectBase from '@/modules/lawn/components/ProjectBase';
import Overview from '@/modules/lawn/views/Overview';
import ActionTracker from '@/modules/projects/views/ActionTracker';
import ProjectInvoices from '@/modules/projects/views/ProjectInvoices';
import ProjectWOs from '@/modules/projects/views/ProjectWOs';
import Dashboard from '@/modules/lawn/views/Dashboard';
import TimesheetDetails from '@/modules/projects/views/timesheetDetails/TimesheetDetails';
import ProjectCrewVisits from '@/modules/projects/views/ProjectCrewVisits';

const routes = [
  {
    path: '/lawn/',
    component: Base,
    meta: { appKey: 'lawnprojects' },
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'LawnDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        },
      },
      {
        path: 'details/:id/',
        component: ProjectBase,
        children: [
          {
            path: 'overview',
            name: 'LawnOverview',
            component: Overview
          },
          {
            path: 'invoices',
            name: 'LawnProjectInvoices',
            component: ProjectInvoices
          },
          {
            path: 'work-orders',
            name: 'LawnProjectWOs',
            component: ProjectWOs
          },
          {
            path: 'action-tracker',
            name: 'LawnActionTracker',
            component: ActionTracker
          },
          {
            path: 'timesheet-details',
            component: TimesheetDetails,
            name: 'LawnTimesheetDetails',
          },
          {
            path: 'crew-visits',
            component: ProjectCrewVisits,
            name: 'LawnCrewVisits',
          }
        ]
      }
    ]
  }
]

export default routes
